import {Pipe, PipeTransform} from '@angular/core';
import {SingleConnection} from "../models";

@Pipe({
    name: 'orderByConnectionKey'
})
export class OrderByConnectionKeyPipe implements PipeTransform {
    transform(connection: SingleConnection[]): SingleConnection[] {
        return connection.sort((a, b) => {
            if (a.key < b.key) return -1;
            if (a.key > b.key) return 1;
            return 0;
        });
    }
}
